import { sum, multiply } from "@/utils/helpers.js";
import { getProfit } from "./utils";
import _MixinsCut from "./MixinsCut";

export default class OceanCut extends _MixinsCut {
  constructor(props) {
    super(props);
    this._roomNum = 0;
    this.minRoomNum = 0;
    this.maxRoomNum = this.last_stock;
  }
  get roomNum() {
    return this._roomNum;
  }
  set roomNum(val) {
    this._roomNum = val;
  }
  get totalPriceList() {
    let len_12 = multiply(this.roomNum, Math.min(this.min_people, 2));
    let len_34 = multiply(this.roomNum, this.min_people) - len_12;
    return [
      {
        title: "第1/2人价格",
        num: len_12,
        totalPrice: multiply(len_12, this.prices.th.adult_price),
        profit: getProfit(
          this.prices.th.adult_price,
          this.prices.sale.adult_price,
          len_12
        )
      },
      {
        title: "第3/4成人价格",
        num: len_34,
        totalPrice: multiply(len_34, this.prices.th.adult34_price),
        profit: getProfit(
          this.prices.th.adult34_price,
          this.prices.sale.adult34_price,
          len_34
        )
      }
    ].filter(row => row.num > 0);
  }
  get totalPrice() {
    return sum(this.totalPriceList.map(row => row.totalPrice));
  }
  get totalProfit() {
    return sum(this.totalPriceList.map(row => row.profit));
  }
}
